export default __webpack_public_path__ + "static/media/team-property-icon.12effa56.svg";